import { io } from 'socket.io-client';
// import { Server } from 'socket.io';

// "undefined" means the URL will be computed from the `window.location` object
export const URL = process.env.NODE_ENV === 'production' ? 'https://natbuddies.onrender.com' : 'http://localhost:4000';
export const socket = io(URL, {
    autoConnect: false
});
export const sessionId = sessionStorage.getItem("sessionId");

if (sessionId) {
    const data = { sessionId: sessionId };
    socket.auth = { data };
}

socket.onAny((event, ...args) => {
    console.log(event, args);
});

// const server = new Server({
//     cors: {
//       origin: "http://localhost:3000"
//     }
// });
  
// server.listen(4000);